import styled from "styled-components";
import "../../bgGlobal.css";

export const DisplayFlexHome = styled.div`
  display: flex;

  .modal-container{
    margin: 0 auto;
    width: 100%;
  }

  .center-fixed{
    width: 100%;
    margin:0 auto;
  }

  .display-filter{
    height: 60px;
    margin: 0 auto;
    display: flex;
    width: 1200px;
    padding: 10px;
    margin-bottom: 25px;
    position: relative;
    top: 10px;
  }

  .btn-home{
    cursor: pointer;
    transition: all 0.3s ease;
    margin: 5px;
    width: 100%;
    height: 18px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 6px;
    padding: 8px 15px;

    box-shadow: var(--box-shadow-btn);
  }

 .selected {
    background-color: var(--bg-white) !important; 
    border: 1px solid var(--bg-secundary);
    color: var(--bg-secundary);
    box-shadow: inset 0px 0px 5px rgba(0,0,0,0.1);
  }
`;